import React from 'react';
import { Skeleton } from '@mui/material';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import Typography from '@src/new-components/Typography';
import { COLOR } from '@src/styles/color';
import PasswordBox from '../../new-components/PasswordBox';
import { StyledChip } from '../PaymentHistory/index.style';

const GeneralInfo = ({ app, isLoading }) => {
  const { t } = useTranslation();

  const renderStatus = (active, expiresAt) => {
    if (moment().isAfter(expiresAt))
      return (
        <div className="center-column">
          <StyledChip color="secondary">{t('expired')}</StyledChip>
        </div>
      );

    if (active)
      return (
        <div className="center-column">
          <StyledChip color="success">{t('active')}</StyledChip>
        </div>
      );

    return (
      <div className="center-column">
        <StyledChip color="error">{t('inactive')}</StyledChip>
      </div>
    );
  };

  return (
    <>
      <div className="container">
        <Typography variant="body-20-bold" color={COLOR.label2[100]}>
          {t('generalInfo')}
        </Typography>
        <div className="general-info-container">
          <div className="generalDetail">
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: 'max-content 1fr',
                gap: '8px',
              }}
            >
              <Typography
                style={{ width: 'max-content' }}
                variant="body-14-medium"
                color={COLOR.label2[64]}
                component="p"
              >
                {t('appName')}:
              </Typography>
              <Typography
                style={{
                  maxWidth: '512px',
                  whiteSpace: 'normal',
                  wordBreak: 'break-word',
                  width: '100%',
                }}
                variant="body-14-bold"
                color={COLOR.label2[100]}
              >
                {isLoading ? (
                  <Skeleton variant="text" width={160} height={24} />
                ) : (
                  app?.name
                )}
              </Typography>
            </div>
            <div
              className="info-detail-app"
              style={{ display: 'flex', flexDirection: 'row', gap: '40px' }}
            >
              <div style={{ width: '208px' }} className="infoDetail">
                <Typography variant="body-14-medium" color={COLOR.label2[64]}>
                  {t('expiry')}:
                </Typography>
                <Typography variant="body-14-bold" color={COLOR.label2[100]}>
                  {isLoading ? (
                    <Skeleton variant="text" width={54} height={24} />
                  ) : (
                    <>
                      {app?.expiresAt
                        ? moment(app.expiresAt).format('DD/MM/YYYY')
                        : t('endless')}
                    </>
                  )}
                </Typography>
              </div>
              <div style={{ width: '208px' }} className="infoDetail">
                <Typography variant="body-14-medium" color={COLOR.label2[64]}>
                  {t('status')}:
                </Typography>
                <Typography variant="body-14-medium" color={COLOR.label2[100]}>
                  {isLoading ? (
                    <Skeleton variant="text" width={54} height={24} />
                  ) : (
                    renderStatus(app?.active, app?.expiresAt)
                  )}
                </Typography>
              </div>
            </div>
          </div>
          <div className="token">
            <div className="infoID">
              <Typography variant="body-14-medium" color={COLOR.label2[100]}>
                {t('generalInfoID')}
              </Typography>
              {isLoading ? (
                <Skeleton variant="text" height={50} />
              ) : (
                <PasswordBox
                  text={app?.id || ''}
                  password={false}
                  bg="#1E164E0A"
                />
              )}
            </div>
            <div className="infoID">
              <Typography variant="body-14-medium" color={COLOR.label2[100]}>
                {t('generalInfoToken')}
              </Typography>
              {isLoading ? (
                <Skeleton variant="text" height={50} />
              ) : (
                <PasswordBox bg="#1E164E0A" text={app?.token || ''} />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default GeneralInfo;
